import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {
    InstalacaoProduto,
    Cliente,
    UserAplicacao,
    ParametroInstalacaoProduto,
    ParametroConteudoInstalacaoProduto
} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';

@Component({
    selector: 'hostname-modal',
    templateUrl: './hostname-modal.component.html',
    styleUrls: ['./hostname-modal.component.css']
})
export class HostnameModalComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, public pesquisaService: PesquisasFiltroApiService,
                public detalhamentoService: DetalhamentoApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
        this.limparCampos();
    }

    private sub: any;

    pagina: number = 1;
    qtdPorPagina: number = 7;
    totalPaginas: number = 1;
    contNrPosicao: number = 1;

    campoBusca = new FormControl('', []);
    sistOperacional = new FormControl('0', []);
    nomeHost = new FormControl('', []);
    ipHost = new FormControl('', []);
    nomeContingencia = new FormControl('', []);
    ipContingencia = new FormControl('', []);
    hostsContingencia = new Array<any>();
    /* sistemaOperacional = ""; */

    cadastraNovaInstalacao: boolean = false;
    resultado: Array<InstalacaoProduto> = null;
    visiveis: Array<InstalacaoProduto> = null;
    selecionado: InstalacaoProduto = null;
    cliente: Cliente = null;
    nomeItemConfiguracao: string = '';
    mensagemErro: string = '';
    mensagemAlerta: string = '';

    hostnameModalForm: FormGroup = this.formBuilder.group({
        campoBusca: this.campoBusca,
    });

    instalacaoModalForm: FormGroup = this.formBuilder.group({
        sistOperacional: this.sistOperacional,
        nomeHost: this.nomeHost,
        ipHost: this.ipHost,
        nomeContingencia: this.nomeContingencia,
        ipContingencia: this.ipContingencia
    });

    ngOnInit() {
        this.mensagemErro = '';
        this.mensagemAlerta = '';
        this.campoBusca.setValue('');
        this.contNrPosicao = 1;

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                if (params['nomeItemConfiguracao'] != '') {
                    this.nomeItemConfiguracao = params['nomeItemConfiguracao'];
                }
                if (params['cadastraNovaInstalacao'] != '') {
                    this.cadastraNovaInstalacao = params['cadastraNovaInstalacao'];
                }
                if (params['instalacao'] != '') {
                    this.selecionado = params['instalacao'];
                }
                if (params['campoBusca'] != '') {
                    this.campoBusca.setValue(params['campoBusca']);
                }
                this.pesquisar();
            });
    }

    limparCampos() {
        this.hostnameModalForm.controls['campoBusca'].reset();
        this.instalacaoModalForm.controls['nomeHost'].reset();
        this.instalacaoModalForm.controls['ipHost'].reset();
        this.instalacaoModalForm.controls['nomeContingencia'].reset();
        this.instalacaoModalForm.controls['ipContingencia'].reset();
    }

    addContingencia() {

        /* TODO
            - Verificar se existe instância connect no hostname
        */

        if (this.nomeContingencia.value == '' || this.ipContingencia.value == '') {
            this.mensagemErro = 'Para adicionar um Hostname de Contingência, o nome e o IP devem estar preenchidos.';
            return false;
        }

        let existe = false;
        this.hostsContingencia.forEach(element => {
            if (element.hostname == this.nomeContingencia.value) {
                existe = true;
            }
        });
        this.hostsContingencia.forEach(element => {
            if (element.ip == this.ipContingencia.value) {
                existe = true;
            }
        });
        if (existe) {
            this.mensagemErro = 'Já foi incluído um Hostname de Contingência com este Nome ou IP.';
            return false;
        }

        this.mensagemErro = '';

        this.hostsContingencia.push({'hostname': this.nomeContingencia.value, 'ip': this.ipContingencia.value});
        this.nomeContingencia.setValue('');
        this.ipContingencia.setValue('');
    }

    delContingencia(hostname: string) {
        this.hostsContingencia.forEach(element => {
            if (element.hostname == hostname) {
                this.hostsContingencia.splice(this.hostsContingencia.indexOf(element), 1);
            }
        });
    }

    novaInstalacao() {

        if (this.sistOperacional.value == '0') {
            this.mensagemErro = 'Informe o Sistema Operacional.';
            return false;
        }

        if (this.ipHost.value == '' || this.ipHost.value == null) {
            this.mensagemErro = 'Informe o IP do hostname a ser cadastrado.';
            return false;
        }

        this.cliente = new Cliente();
        this.cliente.codTipoCliente = 1;
        this.cliente.userAplicacao = new UserAplicacao();
        this.cliente.userAplicacao.codUserAplicacao = 0;
        this.cliente.userAplicacao.versaoUserAplicacao = 0;
        this.cliente.userAplicacao.descricaoUserAplicacao = 'Usuário Impessoal - Uso Interno - Criado via template';
        this.cliente.userAplicacao.nomeUserAplicacao = this.nomeHost.value;

        this.selecionado = new InstalacaoProduto();
        this.selecionado.codigo = 0;
        this.selecionado.versao = 0;
        this.selecionado.nomeItemConfiguracaoProduto = 'Connect_Direct';
        this.selecionado.nomeInstalacao = 'CDT.FTA.NOVA.INSTALACAO';
        this.selecionado.descricaoInstalacao = 'Nova instalação - Criada via template';

        this.selecionado.parmInstalacaoProduto = new Array<ParametroInstalacaoProduto>();
        this.selecionado.itemConfiguracaoVinculado = new Array<string>();

        this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('sistema_operacional', this.sistOperacional.value));
        this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('comm_address', this.ipHost.value));
        this.selecionado.itemConfiguracaoVinculado.push(this.nomeHost.value);
        this.hostsContingencia.forEach(ctg => {
            this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('comm_address', ctg.ip));
            this.selecionado.itemConfiguracaoVinculado.push(ctg.hostname);
        });

        this.confirmar();
    }

    pesquisar() {
        this.mensagemAlerta = '';
        let filtros: Array<any> = new Array<any>();
        this.visiveis = new Array<InstalacaoProduto>();
        this.resultado = new Array<InstalacaoProduto>();
        this.totalPaginas = 1;

        if (this.campoBusca.value == '') {
            this.mensagemAlerta = 'Informe o hostname a ser pesquisado';
            return false;
        }

        this.nomeHost.setValue(this.campoBusca.value);

        filtros.push({
            'filtroInstalacaoProduto': {
                'itemConfiguracaoVinculado': this.campoBusca.value,
                'nomeItemConfiguracaoProduto': this.nomeItemConfiguracao
            }
        });
        this.pesquisaService.filtraInstalacaoProduto(filtros)
            .subscribe(
                listaInstalacoes => {
                    this.resultado = listaInstalacoes as Array<InstalacaoProduto>;
                    this.resultado.sort();
                    this.mudarPagina(1, 'false');
                    this.totalPaginas = Math.ceil(listaInstalacoes.length / this.qtdPorPagina);
                },
                erro => {
                    if (erro.status == 404) {

                    }
                }
            );
    }

    parametroInstalacao(parmNome: string, conteudo: string): ParametroInstalacaoProduto {
        let parmInstalacao: ParametroInstalacaoProduto = new ParametroInstalacaoProduto();
        let parmConteudo: ParametroConteudoInstalacaoProduto = new ParametroConteudoInstalacaoProduto();
        parmInstalacao.parmConteudo = new Array<ParametroConteudoInstalacaoProduto>();
        parmInstalacao.parmNome = parmNome;
        parmConteudo.nrPosicao = this.contNrPosicao;
        parmConteudo.conteudo = conteudo;
        parmInstalacao.parmConteudo.push(parmConteudo);
        this.contNrPosicao++;
        return parmInstalacao;
    }

    selecionaInstalacao(instalacao: InstalacaoProduto) {
        this.globalService.loading = true;
        //this.selecionado = instalacao;
        /* this.sistemaOperacional = ""; */
        this.detalhamentoService.detalhaInstalacaoProduto(instalacao.codigo, instalacao.versao)
            .subscribe(
                resp => {
                    this.selecionado = resp;

                    // Recupera o sistema operacional
                    /* resp.parmInstalacaoProduto.forEach(parm => {
                        if (parm.parmNome == "sistema_operacional") {
                            this.sistemaOperacional = parm.parmConteudo[0].conteudo;
                        }
                    }); */

                    // Recupera os clientes vinculados
                    if (resp.clienteVinculado.length == 0) {
                        // TODO - O que fazer quando não houver cliente vinculado na instalação de produto?
                    }
                    this.cliente = resp.clienteVinculado[0];
                    this.globalService.loading = false;
                });
    }

    mudarPagina(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.pagina = pag;
        this.visiveis = new Array<InstalacaoProduto>();
        let ind = 1;
        this.resultado.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPagina && ind <= pag * this.qtdPorPagina) {
                res.itemConfiguracaoVinculado.sort();
                this.visiveis.push(res);
            }
            ind++;
        });
    }

    confirmar() {
        if (this.selecionado == null) {
            this.mensagemErro = 'Selecione o Item de Configuração ou clique em \'Fechar\'';
        } else {
            let dados = {'instalacao': this.selecionado, 'cliente': this.cliente};
            this.modalService.incluirDadosGerados(dados);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/hostname-modal/hostname-modal.component.ts